<template lang="pug">
    .component-alert-box
        div(:class="'callout '+ color" data-closable)
            slot
            button(v-if="isClosable()" class="close-button" aria-label="Dismiss alert" type="button" data-close)
                span(aria-hidden="true") &times;
</template>
<script type="text/babel">
    export default{
        methods: {
            isClosable(){
             return !(this.closable === undefined || this.closable === false)
            }
        },
        props: ['color', 'size', 'closable']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// AlertBox.vue?743d2b92